module.exports = __webpack_public_path__ + "static/media/logo-polyaire.5c3437b7.svg";